<template>
  <div>
    <v-btn
      class="pa-4"
      small
      @click="getCurrentData"
      :disabled="disableGetCurrentDataBtn"
      >Get Current Data</v-btn
    >
    <v-card width="600px">
      <!-- <v-card-subtitle>What to edit:</v-card-subtitle> -->
      <v-chip>Select what to Edit</v-chip>
      <v-radio-group row class="px-2" v-model="radios" v-if="showRadios"
        ><v-radio label="Name" value="EventName"></v-radio
        ><v-radio label="Location" value="Pos"></v-radio
        ><v-radio label="WhatsApp" value="WhatsAppLink"></v-radio
        ><v-radio label="PureTrack" value="PureTrackGroupLink"></v-radio
      ></v-radio-group>
    </v-card>
    <v-card width="400" outlined v-if="radios === 'EventName'">
      <v-card-title>Edit Box Name and/or Description ></v-card-title>

      <!-- {{this.ac}} -->
      <!-- <v-form v-model="isValid"> -->
      <v-text-field
        v-model="boxname"
        :counter="6"
        outlined=""
        prepend-inner-icon="mdi-text-box-outline"
        placeholder="Box Name"
        required
        :rules="[
          (v) => !!v || 'Box name is required',
          (v) => (v && v.length < 7) || 'Max length 6',
        ]"
      ></v-text-field>
      <v-text-field
        v-model="boxdescription"
        :counter="40"
        outlined=""
        prepend-inner-icon="mdi-text-box-plus-outline"
        placeholder="Description"
        required
        :rules="[
          (v) => !!v || 'Box description is required',
          (v) => (v && v.length < 41) || 'Max length 40',
        ]"
      ></v-text-field>
      <v-card-actions class="justify-center"
        ><v-btn @click="submit">Save Name</v-btn></v-card-actions
      >
      <!-- </v-form> -->
    </v-card>
    <v-card justify="space-around" width="400px" v-if="radios === 'Pos'">
      <v-card-title
        >Edit location for the box
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn icon large v-on="on">
              <v-icon color="green">mdi-information</v-icon>
            </v-btn>
          </template>
          <span>Used to center mapapplications, like SafeSky etc.</span>
        </v-tooltip></v-card-title
      >

      <v-card-subtitle>Zoom and center..</v-card-subtitle>
      <div v-if="posInitiated">
        <SelectMapPosition
          v-bind="postposition"
          @pos_changed="selectedPosition"
        ></SelectMapPosition>
      </div>
      <v-row>
        <v-col>
          <v-text-field
            v-model="lat"
            outlined
            type="Number"
            label="Latitude"
            prepend-inner-icon="mdi-map-marker-plus-outline"
            required
            disabled
          ></v-text-field>
          <!-- :rules="[
                  (v) => !!v || 'Latitude must be a desimal number',
                  (v) => (v && v.length < 21) || 'Max length 20',
                ]" -->
        </v-col>
        <v-col>
          <v-text-field
            v-model="lon"
            outlined
            type="Number"
            label="Longitude"
            prepend-inner-icon="mdi-map-marker-plus-outline"
            required
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card-actions class="justify-center"
        ><v-btn @click="submit">Save Location</v-btn></v-card-actions
      >
    </v-card>
    <v-card width="600" outlined v-if="radios === 'WhatsAppLink'">
      <v-card-title>Edit WhatsApp Link</v-card-title>

      <!-- {{this.ac}} -->
      <!-- <v-form v-model="isValid"> -->
      <v-row class="pa-2">
        <v-text-field
          v-model="whatsAppLink"
          :counter="200"
          outlined=""
          prepend-inner-icon="mdi-text-box-outline"
          placeholder="WhatsAppLink"
          required
          :rules="[
            (v) => !!v || 'Link is required',
            (v) => (v && v.length < 200) || 'Max length 200',
          ]"
          class="pa-2"
        ></v-text-field>
        <v-checkbox
          v-model="whatsAppLinkEnabled"
          label="Enable Link"
          class="pa-2"
        ></v-checkbox>
      </v-row>
      <v-card-actions class="justify-center"
        ><v-btn @click="submit">Save WhatsApp Link</v-btn></v-card-actions
      >
    </v-card>
    <v-card width="600" outlined v-if="radios === 'PureTrackGroupLink'">
      <v-card-title>Edit PureTrack Group Link</v-card-title>

      <!-- {{this.ac}} -->
      <!-- <v-form v-model="isValid"> -->
      <v-row class="pa-2">
        <v-text-field
          v-model="pureTrackGroupLink"
          :counter="200"
          outlined=""
          prepend-inner-icon="mdi-text-box-outline"
          placeholder="PureTrack GroupLink"
          required
          :rules="[
            (v) => !!v || 'Link is required',
            (v) => (v && v.length < 200) || 'Max length 200',
          ]"
          class="pa-2"
        ></v-text-field>
        <v-checkbox
          v-model="pureTrackGroupLinkEnabled"
          label="Enable Link"
          class="pa-2"
        ></v-checkbox>
      </v-row>
      <v-card-actions class="justify-center"
        ><v-btn @click="submit"
          >Save PureTrack Group Link</v-btn
        ></v-card-actions
      >
    </v-card>
    <v-alert type="success" :value="isAlertVisible">
      {{ statusResultMsg }}
    </v-alert>
    <v-alert type="warning" :value="isWarningAlertVisible">
      {{ statusResultMsg }}
    </v-alert>
  </div>
</template>

<script>
import axios from "axios";
import SelectMapPosition from "@/components/airbox/SelectMapPosition.vue";

export default {
  name: "RegForm",
  props: {
    box: [],
    regId: Number,
    ac: String,
  },
  data: () => ({
    boxname: null,
    boxdescription: null,
    isValid: true,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    select: null,
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: { to: "/boxadmin" },
    text: String,
    showComponent: Boolean,
    compValue: String,
    valueInComponent: String,
    radios: null,
    showRadios: false,
    eventId: Number,

    lat: 59.5074,
    lon: 9.9072,
    whatAppLink: String,
    pureTrackGroupLink: String,
    whatAppLinkEnabled: Boolean,
    pureTrackGroupLinkEnabled: Boolean,
    disableGetCurrentDataBtn: false,

    postposition: {
      ilat: Number,
      ilng: Number,
      izoom: Number,
    },
    posSelected: Boolean,
    posInitiated: Boolean,
    selectedLat: Number,
    selectedLng: Number,
    showLocation: Boolean,
  }),

  created() {
    // this.baseUrl = "http://localhost:3000/dbapi/"; //https://pgbox.azurewebsites.net:3000/
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.boxname = null;
    this.boxdescription = null;
    this.statusResult = null;
    this.statusResultMsg = null;
    this.valueInComponent = "no";
    // this.setNationCode();
    this.selectedLat = null;
    this.selectedLng = null;
    this.posSelected = false;
    this.posInitiated = false;
    this.setInitPosition();
    this.showLocation = true;
  },
  methods: {
    submit() {
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var eventName = this.boxname;
      var eventDescription = this.boxdescription;
      var lat = this.lat;
      var lon = this.lon;
      var whatsAppLinkEnabled = this.whatsAppLinkEnabled;
      var pureTrackGroupLinkEnabled = this.pureTrackGroupLinkEnabled;
      var whatsAppLink = this.whatsAppLink;
      var pureTrackGroupLink = this.pureTrackGroupLink;
      var fieldToUpdate = this.radios;
      //   var countrycode = this.valueInComponent
      var toSubmit = JSON.stringify({
        regId,
        ac,
        eventId,
        eventName,
        eventDescription,
        lat,
        lon,
        whatsAppLinkEnabled,
        pureTrackGroupLinkEnabled,
        whatsAppLink,
        pureTrackGroupLink,
        fieldToUpdate,
      });
      const uri = this.baseUrl + "updateEvent";
      //   console.log("uri:", uri);
      //   console.log("toSubmit:", toSubmit);
      this.postRegistration(uri, toSubmit);
      this.disableGetCurrentDataBtn = true;
    },

    postRegistration(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // console.log("response", response.data);
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setNationCode() {
      this.post.id = 1;
      this.post.text = "no";
    },
    setValueMethodInView(value) {
      this.valueInComponent = value;
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    selectedPosition(pos) {
      // console.log("selectedPosition",pos);
      this.selectedLat = pos.lat;
      this.selectedLng = pos.lng;
      this.lat = pos.lat;
      this.lon = pos.lng;
      this.posSelected = true;
    },
    setInitPosition() {
      this.postposition.ilat = 59.5074;
      this.postposition.ilng = 9.9072;
      this.postposition.izoom = 8;
      //   console.log("postposition", this.postposition);
      this.posInitiated = true;
    },
    getCurrentData() {
      //   console.log("getCurrentData", this.box);
      this.eventId = this.box.EventId;
      this.boxname = this.box.Event;
      this.boxdescription = this.box.EventDescription;
      this.lat = this.box.lat;
      this.lon = this.box.lon;
      this.whatsAppLink = this.box.WhatsAppLink;
      this.pureTrackGroupLink = this.box.PureTrackGroupLink;
      this.whatsAppLinkEnabled = this.box.WhatsAppLinkEnabled;
      this.pureTrackGroupLinkEnabled = this.box.PureTrackGroupLinkEnabled;
      this.postposition.ilat = this.box.lat;
      this.postposition.ilng = this.box.lon;
      this.postposition.izoom = 8;
      this.showRadios = true;
    },
  },
  components: {
    // Flags: () => import("@/components/Admin/Flags.vue"), //Denne rendrer ved behov <div v-if..>
    SelectMapPosition,
  },
};
</script>